export const getServerTime = (): number => Date.now();
